import React from 'react';
import {
    View,
    StyleSheet
} from 'react-native';
import { JDText } from '@jdreact/jdreact-core-lib';
import { pt } from '../../common/utils';

export default (props) => {
    const { contentText = '' } = props;

    return (
        <View style={ styles.nomore_wrap }>
            <JDText type='regular' style={ styles.nomore_txt }>{contentText}</JDText>
        </View>
    );
};

const styles = StyleSheet.create({
    nomore_wrap: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: pt(15)
    },
    nomore_txt: {
        color: '#BBBBBB',
        fontSize: pt(12)
    }
});
